import { Chip } from '@mantine/core'
import ChipClasses from './styles.module.css'

export default Chip.extend({
    defaultProps: { color: 'blue' },
    classNames: {
        label: ChipClasses.label,
    },
})
